
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { ISchemaDataDTO } from 'dto/ISchemaDataDTO';

@Component({
  name: 'NodeSummary',
})
export default class NodeSummary extends Vue {
  @Prop({
    type: String,
    required: false,
  })
  title: string;

  @Prop({
    type: Object,
    required: false,
  })
  type: ISchemaDataDTO;
}
